export const BKE_ST_PRINT_REDIRECT = "https://bke.st/redirect";

export function bkeStRedirectUrl(pathname, search = "") {
  return `${BKE_ST_PRINT_REDIRECT}${pathname}${search}`;
}

export function bkeStOrderPrintUrl(orderId, layout) {
  return bkeStRedirectUrl(`/print/order/${orderId}`, `?layout=${layout}`);
}
